import { render } from "./TypeWriterAnimation.vue?vue&type=template&id=8a4d60d4&scoped=true&bindings={\"textLines\":\"props\",\"pageStyle\":\"props\",\"inkStyle\":\"props\",\"linesOnScreen\":\"data\",\"linesNotStarted\":\"data\",\"lineBeingTyped\":\"data\",\"finishedTyping\":\"data\",\"addLetter\":\"options\",\"finishTyping\":\"options\",\"audioPosition\":\"options\"}"
import script from "./TypeWriterAnimation.vue?vue&type=script&lang=js"
export * from "./TypeWriterAnimation.vue?vue&type=script&lang=js"

import "./TypeWriterAnimation.vue?vue&type=style&index=0&id=8a4d60d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8a4d60d4"

export default script